import { render, staticRenderFns } from "./GroupsTabContent.vue?vue&type=template&id=07c6580d&scoped=true&"
import script from "./GroupsTabContent.vue?vue&type=script&lang=js&"
export * from "./GroupsTabContent.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTabContent.vue?vue&type=style&index=0&id=07c6580d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6580d",
  null
  
)

export default component.exports